export function slider() {
  
  //
  const brand_slide = document.querySelector('.brand_slide');
  if(brand_slide) {
    const swiper = new Swiper(brand_slide, {
      loop: true,
      //centeredSlides: true,
      //slidesPerView: 11,
      slidesPerView: "auto",
      spaceBetween: 15,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
          delay: 0,
          disableOnInteraction: false,
          //reverseDirection: true, // 逆回転にするオプション
      },
      breakpoints: {
        768: {
          spaceBetween: 30,
        }
      },
      on: {
        resize: function () {
          this.update();
          if (this.autoplay) this.autoplay.start();
        }
      }
    });
  }
  const brand_slide_reverse = document.querySelector('.brand_slide--reverse');
  if(brand_slide_reverse) {
    const swiper = new Swiper(brand_slide_reverse, {
      loop: true,
      //centeredSlides: true,
      //slidesPerView: 11,
      slidesPerView: "auto",
      spaceBetween: 15,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true, // 逆回転にするオプション
      },
      breakpoints: {
        768: {
          spaceBetween: 30,
        }
      },
      on: {
        resize: function () {
          this.update();
          if (this.autoplay) this.autoplay.start();
        }
      }
    });
  }


  //FIX　共通複数のswiper

  document.querySelectorAll('.p-jprojectBrand_listItem--slide[data-swiper-id]').forEach(swiperEl => {
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1, 
      speed: 600,
      spaceBetween: 10,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'), // 親コンテナ内のpaginationのみ
        clickable: true,
      },
      // navigation: {
      //   nextEl: swiperEl.querySelector('.swiper-button-next'),
      //   prevEl: swiperEl.querySelector('.swiper-button-prev'),
      // },
      breakpoints: { //ブレークポイント
        768: { //横幅が671px以上の場合
          slidesPerView: 3 //3枚表示
        }
      },
    });
  });


  //brand詳細　サムネイルあり

  // サムネイル
  const sliderMain = document.querySelector('.slider_main');
  if(sliderMain) {

    const sliderThumbnail = new Swiper(".slider_thumb", {
      slidesPerView: "auto", // サムネイルの枚数
    });

    const swiper = new Swiper(sliderMain, {
      loop: true,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: sliderThumbnail,
      },
    });
  }


  // real_estate サムネイル
  const reFeature_slide = document.querySelector('.reFeature_slide_main');
  if(reFeature_slide) {

    const reFeature_Thumbnail = new Swiper(".reFeature_slide_thumb", {
      slidesPerView: "auto", // サムネイルの枚数
      direction: 'vertical',
      spaceBetween: 10,
    });

    const swiper = new Swiper(reFeature_slide, {
      loop: true,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: reFeature_Thumbnail,
      },
    });
  }


}